export default "__VITE_ASSET__e4dd891c__"